module.exports = __webpack_public_path__ + "img/案例1.d000a165.png";